class FormLightbox {
  constructor() {
    this.close = document.querySelectorAll(
      '#btn-close-form, [data-action="close-form"]',
    );
    this.component = document.getElementById('form-lightBox');
    this.open = document.getElementById('form-popup');
    this.elements = document.querySelectorAll('[data-form]');

    if (!this.component) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    this.close.forEach((closeElement) => {
      closeElement.addEventListener('click', this.onClickClose.bind(this));
    });
    this.elements.forEach((element) => {
      element.addEventListener('click', this.onClickOpen.bind(this));
    });
  }

  onClickClose() {
    this.component.classList.remove('active');
    document.body.classList.remove('light-box-active');
  }

  onClickOpen(event) {
    if (event.currentTarget.getAttribute('href') !== '#') {
      return;
    }

    document.body.classList.add('light-box-active');

    event.preventDefault();
    const data = JSON.parse(event.currentTarget.getAttribute('data-form'));

    if (!data) {
      return;
    }

    document.body.style.position = 'relative';
    document.getElementById('title-form').innerHTML = data.title;
    document.getElementById('subtitle-form').innerHTML = data.subtitle;
    document.getElementById('text-form').innerHTML = data.description;

    const currentForm = document.getElementsByClassName('active-form');

    if (currentForm) {
      [].forEach.call(currentForm, (form) => {
        form.classList.remove('active-form');
      });
    }
    document
      .getElementById(`gf-id-${data.form_target}`)
      .classList.toggle('active-form');

    this.component.classList.add('active');
  }
}

export default new FormLightbox();
